import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { INotificationKindsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<INotificationKindsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.notificationKinds");

export const notificationKinds = {
  ...getAllApis,
};
